
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2f0727bc&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GroupMaster.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GroupMaster.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2f0727bc!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GroupMaster.vue"),
  /* scopeId */
  "data-v-2f0727bc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/company/GroupMaster.vue
// module id = 796
// module chunks = 0